<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Crear Usuario",
            items: [
                {
                text: "Usuarios",
                href: "/web/configuracion/usuarios"
                },
                {
                text: "Crear Usuario",
                active: true
                }
            ],
            datos:{
                sede:'',
                tipo:'',
                rut:'',
                name:'',
                email:'',
                telefono:'',
                cargo:'',
                rol:'',
                carrera:'',
                ano:'',
                retencion:'',
                banco:'',
                tipo_cuenta:'',
                n_cuenta:''
            },
            bool_usuarios:true,
            bool_laborantes:false,
            usuario:'',
            emailError:'',
            phoneerror:'',
            ruterror:'',
            bancos:[],
            tipo:['Cuenta Vista', 'Cuenta Rut', 'Cuenta Corriente', 'Cuenta Ahorro'],
            retencion:['14,5'],
            sedes:['Viña del Mar', 'Santiago', 'Concepción'],
            cargos:['Coordinador Vigente','Coordinador de reemplazo','Supervisor','Supervisor General', 'Laborante']
        };
    },
    computed:{
        isEmailValid() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.datos.email);
        }
    },
    methods: {
        msg(tipo,titulo, text){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                text: text,
                showConfirmButton: false,
                timer: 5000
            });
        },
        validacion_usuario(){
            if(this.datos.cargo=='' || this.datos.cargo==null){
                this.msg('error','Falta campo por completar','Tipo de Usuario');
                return
            }
            if(this.datos.rut=='' || this.datos.rut==null){
                this.msg('error','Falta campo por completar','Rut');
                return
            }
            if(this.datos.name=='' || this.datos.name==null){
                this.msg('error','Falta campo por completar','Nombre');
                return
            }
            if(this.datos.email=='' || this.datos.email==null){
                this.msg('error','Falta campo por completar','Correo');
                return
            }
            if(this.datos.telefono=='' || this.datos.telefono==null){
                this.msg('error','Falta campo por completar','Teléfono');
                return
            }
            this.crear_usuario();
        },
        validacion_laborates(){
            if(this.datos.rut=='' || this.datos.rut==null){
                this.msg('error','Falta campo por completar','Rut');
                return
            }
            if(this.datos.name=='' || this.datos.name==null){
                this.msg('error','Falta campo por completar','Nombre');
                return
            }
            if(this.datos.email=='' || this.datos.email==null){
                this.msg('error','Falta campo por completar','Correo');
                return
            }
            if(this.datos.telefono=='' || this.datos.telefono==null){
                this.msg('error','Falta campo por completar','Teléfono');
                return
            }
            this.datos.rol='Laborante';
            this.crear_usuario();
        },
        crear_usuario(){
            if (this.datos.cargo=='Coordinador Vigente') {
                this.datos.rol='Coordinador';
            }else if(this.datos.cargo=='Coordinador de Reemplazo'){
                this.datos.rol='Coordinador';
            }else if(this.datos.cargo=='Supervisor'){
                this.datos.rol='Supervisor';
            }else if(this.datos.cargo=='Supervisor General'){
                this.datos.rol='Admin';
            }else if(this.datos.cargo==''){
                this.datos.rol='Laborante';
            }
            let formData = new FormData();
            formData.append('sede', this.datos.sede);
            formData.append('tipo', this.datos.tipo);
            formData.append('rut', this.datos.rut);
            formData.append('name', this.datos.name);
            formData.append('email', this.datos.email);
            formData.append('telefono', this.datos.telefono);
            formData.append('cargo', this.datos.cargo);
            formData.append('rol', this.datos.rol);
            formData.append('carrera', this.datos.carrera);
            formData.append('ano', this.datos.ano);
            formData.append('retencion', this.datos.retencion);
            let bancoVal = '';
            if (this.datos.banco && typeof this.datos.banco === 'object' && this.datos.banco.id) {
                bancoVal = this.datos.banco.id;
            } else if (this.datos.banco) {
                bancoVal = this.datos.banco;
            }
            formData.append('banco', bancoVal);
            formData.append('tipo_cuenta', this.datos.tipo_cuenta);
            formData.append('n_cuenta', this.datos.n_cuenta);
            axios.post('/api/crear_usuario',formData).then(res=>{
                if(res.data.estado){
                    this.msg(res.data.color,res.data.mensaje);
                }else{
                    this.msg(res.data.color,res.data.mensaje);
                }
                this.datos.sede='';
                this.datos.tipo='';
                this.datos.rut='';
                this.datos.name='';
                this.datos.email='';
                this.datos.telefono='';
                this.datos.cargo='';
                this.datos.rol='';
                this.datos.carrera='';
                this.datos.ano='';
                this.datos.retencion='';
                this.datos.banco='';
                this.datos.tipo_cuenta='';
                this.datos.n_cuenta='';
            })
        },
        usuarios(){
            this.datos.sede='';
            this.datos.tipo='';
            this.datos.rut='';
            this.datos.name='';
            this.datos.email='';
            this.datos.telefono='';
            this.datos.cargo='';
            this.datos.rol='';
            this.datos.carrera='';
            this.datos.ano='';
            this.datos.retencion='';
            this.datos.banco='';
            this.datos.tipo_cuenta='';
            this.datos.n_cuenta='';
            this.bool_usuarios=true;
            this.bool_laborantes=false;
        },
        laborantes(){
            this.datos.sede='';
            this.datos.tipo='';
            this.datos.rut='';
            this.datos.name='';
            this.datos.email='';
            this.datos.telefono='';
            this.datos.cargo='';
            this.datos.rol='';
            this.datos.carrera='';
            this.datos.ano='';
            this.datos.retencion='';
            this.datos.banco='';
            this.datos.tipo_cuenta='';
            this.datos.n_cuenta='';
            this.bool_usuarios=false;
            this.bool_laborantes=true;
        },
        formatRut() {
            // Eliminamos todos los caracteres que no sean números o 'k'
            let cleanRut = this.datos.rut.replace(/[^0-9kK]/g, "").toUpperCase();
            if (cleanRut.length > 10) {
                cleanRut = cleanRut.slice(0, 10); // Limitar a 9 dígitos + DV
            }
            // Si el RUT tiene más de un carácter, separamos el dígito verificador
            if (cleanRut.length > 1) {
                const body = cleanRut.slice(0, -1); // Todo menos el último carácter
                const dv = cleanRut.slice(-1); // Último carácter como dígito verificador
                // Agregamos los puntos cada tres dígitos al cuerpo
                const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                // Concatenamos el cuerpo formateado con el dígito verificador
                this.datos.rut = `${formattedBody}-${dv}`;
            } else {
                // Si el RUT tiene un solo carácter, lo dejamos tal cual
                this.datos.rut = cleanRut;
            }
        },
        cleanRut(value) {
            return value.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
        },
        validateRut() {
            let rut = this.cleanRut(this.datos.rut);
            let digito_verificador = this.datos.rut.substr(-1);
            rut = rut.substr(0, rut.length - 1);
            let serie = 0;
            let producto = 0;
            do {
                producto += (rut % 10) * ((serie % 6) + 2);
                serie++;
            } while (rut = Math.floor(rut / 10));
            let resto = producto % 11;
            let resultado = 11 - resto;
            if (resultado == 11) {
                resultado = 0;
            } else if (resultado == 10) {
                resultado = 'K';
            }
            if (digito_verificador != resultado || digito_verificador=='') {
                this.ruterror = 'RUT inválido';
            } else {
                this.ruterror = '';
            }
        },
        validateEmail() {
            if (this.datos.email && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.datos.telefono.replace(/\D/g, "");
            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }
            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }
            // Actualiza el input con el formato correcto
            this.datos.telefono = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.datos.telefono.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        restrictInput(event) {
            // Permitir solo letras y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);
            if (!isLetter && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        restrictInput_withspace(event) {
            // Permitir solo letras, espacios y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-Z\s]$/.test(event.key);

            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        cuenta_rut(rut){
            if(this.datos.tipo_cuenta=='Cuenta Rut'){

                this.datos.n_cuenta = this.datos.rut.replace(/[.\-]/g, "");
            }else{
                this.datos.n_cuenta = ''
            }
        }
    },
    created(){
        if (localStorage.getItem("usuario")) {
            const usuario = localStorage.getItem("usuario");
            this.usuario = usuario;
            if (this.usuario=='usuario') {
                this.bool_usuarios=true;
                this.bool_laborantes=false;
            }
            if(this.usuario=='laborante'){
                this.bool_usuarios=false;
                this.bool_laborantes=true;
            }
            localStorage.removeItem("usuario");
        }
        axios.get('/api/get_bancos').then(response => {
            this.bancos = response.data.bancos;
        });
        
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card text-center mt-3">
                    <div class="card-body">
                        <!-- <b-button variant="primary" @click="laborantes">Laborantes</b-button> -->
                        <b-button variant="primary" @click="usuarios">Usuarios</b-button>
                    </div>
                </div>
                <div class="card mt-3" v-if="bool_usuarios">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <!-- <b-form-group label="Sede :" label-for="input-default">
                                    <multiselect
                                        v-model="datos.sede"
                                        :options="sedes" 
                                        placeholder="Seleccionar opción" 
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group> -->
                                <b-form-group label="Nombre :" label-for="input-default">
                                    <b-form-input class="border-primary" id="input-name" v-model="datos.name" @keydown="restrictInput_withspace"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Correo :" label-for="input-default">
                                    <b-form-input class="border-primary" id="input-email" v-model="datos.email" @blur="validateEmail"></b-form-input>
                                    <p v-if="emailError" class="error text-primary">{{ emailError }}</p>
                                </b-form-group>
                                <b-form-group label="Tipo de Usuario :" label-for="input-default">
                                    <multiselect
                                        v-model="datos.cargo"
                                        :options="cargos" 
                                        placeholder="Seleccionar opción" 
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                                
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Rut :" label-for="input-default">
                                    <b-form-input class="border-primary" id="input-rut" v-model="datos.rut" @blur="validateRut" @input="formatRut" maxlength="12"></b-form-input>
                                    <p v-if="ruterror" class="error text-primary">{{ ruterror }}</p>
                                </b-form-group>
                                <b-form-group label="Teléfono :" label-for="input-default">
                                    <b-form-input type="phone" class="border-primary" id="input-telefono" v-model="datos.telefono" @input="formatPhoneNumber" @blur="validatePhoneNumber" @keydown="restrictToNumbers" maxlength="12"></b-form-input>
                                    <p v-if="phoneerror" class="error text-primary">{{ phoneerror }}</p>
                                </b-form-group>
                            </div>
                            <p class="col-lg-12 text-primary">Todos los campos son obligatorios</p>
                            <div class="offset-lg-3 col-lg-6">
                                <b-button block variant="primary" @click="validacion_usuario">Agregar</b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mt-3" v-if="bool_laborantes">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label class="col-md-6"> Rut:</label>
                                    <label for="pais" class="text-primary col-md-6 text-right"> * Campo Obligatorio</label>
                                    <div class="col-md-12">
                                        <input type="text" id="rut" v-model="datos.rut" class="form-control border-primary" @blur="validateRut" @input="formatRut()" maxlength="12">
                                        <p v-if="ruterror" class="error text-primary">{{ ruterror }}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-6"> Nombre:</label>
                                    <label for="pais" class="text-primary col-md-6 text-right"> * Campo Obligatorio</label>
                                    <div class="col-md-12">
                                        <input type="text" id="name" v-model="datos.name" class="form-control border-primary" @keydown="restrictInput_withspace">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-6"> Correo:</label>
                                    <label for="pais" class="text-primary col-md-6 text-right"> * Campo Obligatorio</label>
                                    <div class="col-md-12">
                                        <input type="text" id="email" v-model="datos.email" class="form-control border-primary" @blur="validateEmail">
                                        <p v-if="emailError" class="error text-primary">{{ emailError }}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-6"> Teléfono:</label>
                                    <label for="pais" class="text-primary col-md-6 text-right"> * Campo Obligatorio</label>
                                    <div class="col-md-12">
                                        <input type="text" id="telefono" v-model="datos.telefono" class="form-control border-primary" @input="formatPhoneNumber" @blur="validatePhoneNumber" @keydown="restrictToNumbers" maxlength="12">
                                        <p v-if="phoneerror" class="error text-primary">{{ phoneerror }}</p>
                                    </div>
                                </div>
                                <b-form-group label="Carrera :" label-for="input-default">
                                    <b-form-input class="border-primary" id="input-carrera" v-model="datos.carrera"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Año :" label-for="input-default">
                                    <b-form-input class="border-primary" id="input-año" v-model="datos.ano"></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Sede :" label-for="input-default">
                                    <multiselect
                                        v-model="datos.sede"
                                        :options="sedes" 
                                        placeholder="Seleccionar opción" 
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                                <b-form-group label="% retención :" label-for="input-default">
                                    <multiselect
                                        v-model="datos.retencion"
                                        :options="retencion" 
                                        placeholder="Seleccionar opción" 
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                    <!-- <b-form-input class="border-primary" id="input-retencion" v-model="datos.retencion"></b-form-input> -->
                                </b-form-group>
                                <b-form-group label="Banco :" label-for="input-default">
                                    <multiselect
                                        v-model="datos.banco"
                                        :options="bancos" 
                                        :custom-label="labelselect_tipo" 
                                        placeholder="Seleccionar opción" 
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                    <!-- <b-form-input class="border-primary" id="input-banco" v-model="datos.banco"></b-form-input> -->
                                </b-form-group>
                                <b-form-group label="Tipo cuenta :" label-for="input-default">
                                    <multiselect
                                        v-model="datos.tipo_cuenta"
                                        :options="tipo" 
                                        placeholder="Seleccionar opción" 
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        @select="cuenta_rut"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                                <b-form-group label="Nº Cuenta :" label-for="input-default">
                                    <b-form-input class="border-primary" id="input-n_cuenta" v-model="datos.n_cuenta"></b-form-input>
                                </b-form-group>
                                
                            </div>
                            <div class="offset-lg-3 col-lg-6">
                                <b-button block variant="primary" @click="validacion_laborates">Agregar</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>